export default {
    auth: {
        attendance_success: "📅 Điểm danh hoàn tất! (Daily Rewards)\nĐã nhận thưởng hôm nay +50 điểm!",
        signup_bonus: "Đăng ký thành công! 🎉\nĐã nhận thưởng chào mừng +100 điểm!",
        referral_bonus: "Đăng ký qua giới thiệu hoàn tất! 🤝\nThưởng chào mừng 100P + Thưởng giới thiệu 500P\nTổng cộng đã nhận 600 điểm!",
        login_required: "Yêu cầu đăng nhập"
    },
    social: {
        subscribe_on: "Đã thêm vào danh sách theo dõi.",
        subscribe_off: "Đã hủy theo dõi.",
        like_on: "Đã thích!",
        like_off: "Đã bỏ thích.",
        follow_on: "Đã theo dõi.",
        follow_off: "Đã hủy theo dõi."
    },
    comment: {
        submit_success: "Đã đăng bình luận.",
        delete_confirm: "Bạn có chắc chắn muốn xóa?",
        delete_success: "Đã xóa.",
        delete_error: "Lỗi khi xóa",
        submit_error: "Lỗi khi đăng bình luận",
        empty_error: "Vui lòng nhập nội dung."
    },
    payment: {
        verify_success: "Xác minh hoàn tất!\nĐã nạp {amount} Sao.",
        verify_fail: "Lỗi xác minh",
        user_cancel: "Thanh toán đã bị hủy.",
        error: "Lỗi thanh toán"
    },
    common: {
        confirm: "Xác nhận",
        cancel: "Hủy",
        close: "Đóng",
        save: "Lưu",
        delete: "Xóa",
        edit: "Sửa",
        copy: "Sao chép",
        loading: "Đang tải...",
        error: "Đã xảy ra lỗi.",
        success: "Thành công.",
        webtoon: "Webtoon",
        webnovel: "Tiểu thuyết mạng",
        cinenovel: "Cine-Novel",
        published: "Đã xuất bản",
        draft: "Bản nháp",
        editor: "Trình biên tập"
    },
    seo: {
        default_title: "Mirinae Platform - Where Imagination Becomes Reality",
        default_desc: "Next-gen Webtoon/Webnovel platform combining AI and Art. Become an author and create your own universe."
    },
    footer: {
        terms: "Điều khoản sử dụng",
        privacy: "Chính sách bảo mật",
        report: "Trung tâm khiếu nại",
        biz_ceo: "Giám đốc",
        biz_addr: "Địa chỉ",
        biz_tel: "Hỗ trợ",
        biz_email: "Email",
        biz_license: "Giấy phép",
        biz_mail_order: "TMĐT",
        biz_none: "Không có thông tin",
        system_ready: "SYSTEM READY",
        copyright: "SSULWHA WORLD"
    },
    menu: {
        home: "Trang chủ",
        webtoon: "Webtoon",
        webnovel: "Tiểu thuyết mạng",
        novel: "Tiểu thuyết mạng",
        davinci: "Da Vinci",
        studio: "Studio Tác giả",
        library: "Thư viện",
        support: "Hỗ trợ",
        admin: "Quản trị",
        config: "Liên kết ngoài",
        factory: "Popup & Thông báo",
        docs: "Soạn thảo tài liệu",
        analytics: "Phân tích xu hướng",
        plaza: "Ssulwha Club",
        wisdom: "Trí tuệ của Sao",
        recommendation: "Kệ sách trống",
        charge: "Trạm Ngôi Sao",
        guide: "Hướng dẫn",
        "whats-new": "Có gì mới",
        invite: "Mời bạn bè",
        about: "Giới thiệu",
        terms: "Điều khoản sử dụng",
        privacy: "Chính sách bảo mật",
        report: "Trung tâm khiếu nại",
        "app-setting": "Cài đặt ứng dụng",
        login: "Đăng nhập / Đăng ký",
        logout: "Đăng xuất",
        MyPage: "Trang của tôi",
        notice: "Thông báo",
        proposal: "Đề xuất",
        settings: "Cài đặt",
        language: "Ngôn ngữ"
    },
    modal: {
        translate_title: "Chọn ngôn ngữ",
        translate_placeholder: "Vui lòng chọn ngôn ngữ để dịch.",
        translate_start: "Dịch"
    },
    msg: {
        welcome_beta: "Chào mừng đến với phiên bản Beta của Mirinae.",
        login_required: "Đăng nhập để mở khóa thêm nhiều câu chuyện.",
        login_btn: "Đăng nhập / Đăng ký"
    },
    profile: {
        follow: "Theo dõi",
        following: "Đang theo dõi",
        mypage: "Trang của tôi",
        followers: "Người theo dõi",
        following_count: "Đang theo dõi",
        bio_empty: "Chưa có giới thiệu.",
        works: "Tác phẩm",
        feed: "Bảng tin",
        guestbook: "Sổ tay",
        works_empty: "Chưa có tác phẩm nào.",
        works_error: "Lỗi tải tác phẩm",
        feed_empty: "Chưa có bài đăng nào.",
        feed_error: "Lỗi tải bảng tin.",
        feed_error_detail: "Đang tạo chỉ mục hoặc lỗi mạng.",
        follow_error: "Lỗi khi theo dõi."
    },
    support: {
        title: "Trung tâm Hỗ trợ 1:1",
        input_placeholder: "Nhập nội dung thắc mắc...",
        empty_state_title: "Không có lịch sử tư vấn.",
        empty_state_desc: "Hãy hỏi chúng tôi bất cứ lúc nào!",
        status_received: " • Đã tiếp nhận",
        auto_reply: "Ý kiến của bạn đã được tiếp nhận. Chúng tôi sẽ trả lời theo thứ tự. Trong thời gian chờ đợi, hãy khám phá Ssulwha World.",
        send_fail: "Gửi tin nhắn thất bại"
    },
    author: {
        apply_title: "Đăng ký Tác giả",
        apply_desc: "Chia sẻ câu chuyện của bạn với thế giới. Để lại giới thiệu ngắn và hồ sơ năng lực, chúng tôi sẽ liên hệ sau khi xem xét.",
        email_label: "Email",
        email_placeholder: "Nhập email liên hệ",
        email_hint: "Chúng tôi có thể liên hệ với bạn về kết quả phê duyệt và hợp đồng.",
        intro_label: "Giới thiệu",
        intro_placeholder: "Vui lòng giới thiệu bản thân (Kinh nghiệm viết, phong cách, v.v.)",
        portfolio_label: "Hồ sơ năng lực (Tùy chọn)",
        submit_btn: "Đăng ký ngay",
        email_required: "Vui lòng nhập email của bạn.",
        intro_required: "Vui lòng nhập phần giới thiệu.",
        submitting: "Đang gửi...",
        submit_success: "Đã gửi đăng ký tác giả."
    },
    point: {
        reason: {
            attendance: "Daily Attendance",
            reading: "Reading Reward",
            reading_reward: "Reading Reward",
            welcome: "Welcome Reward",
            referral: "Referral Reward",
            author_apply: "Author Application",
            rental: "Rental",
            purchase: "Purchase"
        }
    },
    wallet: {
        tab_title: "Wallet",
        sub_card: {
            upgrade_btn: "Upgrade Membership (₩{price}/mo)",
            coming_soon: "Coming Soon",
            tier_label: "Membership Tier",
            tier_premium: "Premium Pass",
            tier_standard: "Standard Member",
            renews_on: "Renews on"
        },
        assets: {
            activity_label: "Activity Points",
            activity_desc: "Free Earned Points",
            star_label: "Star Points",
            star_desc: "Paid Charged Points"
        },
        charge: {
            title: "Star Station",
            desc: "Charge needed stars"
        },
        history: {
            title: "Point History",
            empty: "No history found."
        }
    },
    history: {
        empty: {
            title: "No history yet.",
            desc: "Shall we explore some works?",
            action_btn: "Go Explore"
        },
        common: {
            no_title: "No Title"
        },
        last_viewed: "Last viewed:",
        episode_fmt: "Ep. {n}",
        delete_confirm: {
            msg: "Do you want to delete this history?",
            title: "Delete History"
        }
    },
    library: {
        empty_title: "Thư viện trống",
        empty_desc: "Các tác phẩm đã mua hoặc đã xem sẽ xuất hiện tại đây.",
        explore_btn: "Khám phá Tác phẩm",
        select_hint: "Chọn một tác phẩm để xem danh sách.",
        total_episodes: "Tổng cộng {n} tập"
    },
    badge: {
        best_reviewer: "Nhà phê bình hàng đầu",
        top_author: "Tác giả hàng đầu",
        vip: "VIP",
        donation_king: "Vua donate",
        hall_of_fame: "Đại sảnh danh vọng"
    },
    tab: {
        works: "Tác phẩm",
        feed: "Ssulwha (Feed)",
        guestbook: "Sổ tay khách"
    },
    tag: {
        fantasy: "Kỳ ảo",
        romance: "Lãng mạn",
        martial_arts: "Võ hiệp",
        drama: "Chính kịch",
        slice_of_life: "Đời thường",
        comedy: "Hài hước",
        thriller: "Giật gân",
        school: "Học đường",
        munchkin: "Munchkin",
        regression: "Hồi quy",
        possession: "Nhập hồn",
        system: "Hệ thống",
        growth: "Phát triển",
        revenge: "Báo thù",
        heart: "Trái tim",
        horror: "Kinh dị",
        sport: "Thể thao",
        history: "Lịch sử giả tưởng"
    },
    guestbook: {
        title: "Sổ tay",
        input_placeholder: "Để lại lời nhắn ủng hộ!",
        secret: "Bí mật",
        submit: "Gửi",
        empty: "Hãy là người đầu tiên để lại lời nhắn! 👣",
        secret_content: "Đây là tin nhắn bí mật.",
        delete_confirm: "Bạn có chắc chắn muốn xóa?",
        reply: "Trả lời",
        reply_placeholder: "Viết câu trả lời...",
        reply_delete_confirm: "Xóa câu trả lời?",
        confirm_delete_reply: "Xóa câu trả lời này?",
        submit_error: "Gửi thất bại: ",
        emoji_error: "Lỗi tải biểu tượng cảm xúc"
    },
    pwa: {
        install_title: "Cài đặt",
        install_desc: "Trải nghiệm nhanh và mượt hơn.",
        install_btn: "Cài đặt",
        later_btn: "Để sau",
        ios_guide_title: "Cài đặt trên iPhone",
        ios_guide_desc: "Tận hưởng trải nghiệm toàn màn hình.",
        ios_step1: "Nhấn nút 'Chia sẻ'",
        ios_step2: "Chọn 'Thêm vào MH chính'",
        update_title: "Phiên bản mới ({version})!",
        update_title_v2: "Đã có bản cập nhật mới!",
        update_desc: "Cập nhật để có tính năng mới.",
        update_btn: "Cập nhật",
        updating: "Đang cập nhật...",
        offline_title: "Bạn đang ngoại tuyến",
        offline_desc: "Vui lòng kiểm tra internet.",
        copy_success: "Đã sao chép",
        copy_fail: "Lỗi sao chép"
    },
    settings: {
        title: "Cài đặt ứng dụng",
        general: "Cài đặt chung",
        push_title: "Thông báo đẩy",
        push_desc: "Nhận thông báo cập nhật",
        app_info: "Thông tin ứng dụng",
        current_version: "Phiên bản hiện tại",
        danger_zone: "Danger Zone",
        delete_account_title: "Xóa tài khoản (Trở về thực tại)",
        delete_account_desc: "Tất cả dữ liệu sẽ bị xóa và không thể khôi phục.",
        delete_account_button: "Trở về thực tại"
    },
    proposal: {
        title: "Trí tuệ của Sao",
        desc: "Trí tuệ tỏa sáng của bạn mở rộng vũ trụ.",
        label_title: "Tiêu đề đề xuất",
        placeholder_title: "Nhập cốt lõi ý tưởng của bạn",
        label_content: "Chi tiết",
        placeholder_content: "Chia sẻ ý tưởng của bạn một cách tự do. Càng cụ thể càng tốt!",
        btn_submit: "Gửi Trí tuệ",
        success_title: "Đã nhận Trí tuệ",
        success_desc: "Trí tuệ của {name} đã được ghi nhận.<br>Cảm ơn phản hồi quý giá của bạn."
    },
    report: {
        title: "Trung tâm khiếu nại",
        category_label: "DANH MỤC",
        content_label: "NỘI DUNG",
        url_label: "URL LIÊN QUAN",
        categories: {
            general: "Câu hỏi chung / Khác",
            spam: "Spam / Quảng cáo không phù hợp",
            abuse: "Lăng mạ / Ngôn từ thù địch",
            adult: "Nội dung người lớn / Có hại cho trẻ vị thành niên",
            bug: "Lỗi hệ thống / Bug"
        },
        placeholder_content: "Vui lòng mô tả vấn đề chi tiết.",
        btn_submit: "Gửi khiếu nại",
        warning: "Khiếu nại sai sự thật có thể dẫn đến hạn chế dịch vụ.",
        success_title: "Đã gửi khiếu nại",
        success_desc: "Chúng tôi sẽ xem xét và xử lý nhanh chóng.<br>Cảm ơn bạn đã báo cáo.",
        login_required: "Bạn cần đăng nhập để gửi khiếu nại.",
        submit_success: "Khiếu nại đã được gửi thành công.\nVui lòng kiểm tra trong trung tâm quản trị...",
        error: "Lỗi khi gửi khiếu nại",
        modal: {
            title: "Report",
            desc: "Please select a reason. False reports may result in service restrictions.",
            category: "Category",
            detail: "Detail",
            url: "Related URL",
            submit: "Submit",
            cancel: "Cancel"
        },
        reason: {
            spam: "Spam / Promotion",
            abusive: "Abusive Language",
            inappropriate: "Inappropriate Content",
            other: "Other / Inquiry"
        }
    },
    guide: {
        title: "Cài đặt hệ thống",
        desc: "Chúng tôi đang tinh chỉnh chiếc la bàn<br>để hỗ trợ hành trình của bạn.",
        wait: "Vui lòng đợi trong giây lát."
    },
    viewer: {
        settings_title: "Cài đặt Âm thanh/Cuộn",
        bgm_volume: "Âm lượng BGM",
        bgm_off: "Tắt BGM",
        auto_speed: "Tốc độ tự động",
        settings_btn: "Cài đặt",
        translate_btn: "Dịch AI",
        tts_btn: "Đọc TTS",
        bgm_btn: "BGM",
        top_btn: "Lên đầu",
        auto_play: "Tự động trượt",
        auto_scroll: "Tự động cuộn",
        start_auto: "Tự động phát",
        stop_auto: "Đã dừng",
        tts_warn: "Lưu ý: TTS đọc bằng ngôn ngữ gốc (tiếng Hàn)."
    },
    login: {
        subtitle: "Nơi trí tưởng tượng trở thành hiện thực",
        btn_google: "Tiếp tục với Google",
        or: "HOẶC",
        label_email: "Email",
        label_password: "Mật khẩu",
        btn_email_login: "Đăng nhập bằng Email",
        btn_email_signup: "Đăng ký bằng Email",
        msg_no_account: "Chưa có tài khoản?",
        msg_has_account: "Đã có tài khoản?",
        btn_signup: "Đăng ký",
        btn_login: "Đăng nhập",
        msg_processing: "Đang xử lý...",
        msg_email_sent: "Email xác thực đã được gửi. Vui lòng kiểm tra và đăng nhập.",
        err_invalid_auth: "Email hoặc mật khẩu không đúng.",
        err_email_in_use: "Email đã được sử dụng.",
        err_default: "Đã xảy ra lỗi."
    },
    terms: {
        title: "Kiểm soát nhập cư",
        desc: "Chào mừng đến với thế giới SSULWHA.<br>Vui lòng đồng ý với các điều khoản.",
        required: "[Bắt buộc]",
        optional: "[Tùy chọn]",
        label_terms: "Điều khoản dịch vụ",
        label_privacy: "Chính sách bảo mật",
        label_marketing: "Đồng ý tiếp thị",
        btn_start: "Bắt đầu",
        btn_processing: "Đang xử lý..."
    },
    main: {
        banner_welcome: "✨ Khám phá thế giới SSULWHA ngay hôm nay!",
        search_placeholder: "Tìm tác phẩm, tác giả, thẻ...",
        hall_of_fame: "Đại sảnh danh vọng (Weekly Best)",
        hall_of_fame_locked: "Đại sảnh danh vọng chỉ dành cho thành viên",
        hall_of_fame_desc: "Ai là người dùng tích cực nhất tuần này? Đăng nhập để xem xếp hạng!",
        login_btn: "Đăng nhập",
        todays_pick: "Lựa chọn hôm nay",
        continue_reading: "Tiếp tục đọc",
        trending: "Xu hướng",
        new_arrivals: "Mới cập nhật",
        all_works: "Tất cả tác phẩm",
        tag_cloud: "Theo thẻ",
        filter_all: "Tất cả",
        filter_webtoon: "Webtoon",
        filter_webnovel: "Tiểu thuyết mạng",
        realtime_club: "CLB Ssulwha thời gian thực",
        enter_club: "Tham gia",
        be_the_first: "Phóng ngôi sao đầu tiên!",
        go_to_plaza: "Đến quảng trường",
        search_results: "Kết quả tìm kiếm: '{query}'",
        search_no_results: "Không tìm thấy kết quả.",
        search_try_other: "Thử từ khóa khác.",
        splash_loading: "Đang vào thế giới Ssulwha...",
    },
    mypage: {
        tab_library: "Thư viện",
        tab_history: "Lịch sử",
        tab_activity: "Hoạt động",
        tab_likes: "Yêu thích",
        tab_wallet: "Ví",
        tab_settings: "Cài đặt",
        no_activity: "Không có hoạt động.",
        go_to_plaza: "Đến quảng trường",
        followers: "Người theo dõi",
        following: "Đang theo dõi",
        edit_profile_tooltip: "Sửa hồ sơ",
        role_author: "Tác giả",
        role_reader: "Độc giả",
        role_admin: "Admin",
        author_pending: "⏳ Đang chờ duyệt",
        btn_studio: "Studio Tác giả",
        btn_apply_author: "Trở thành Tác giả",
        default_bio: "Nhập giới thiệu ngắn gọn.",
        menu_edit_profile: "Chỉnh sửa hồ sơ",
        menu_public_profile: "Hồ sơ công khai",
        current_version: "Phiên bản hiện tại",
        invite_title: "Mời bạn bè",
        invite_reward: "Thưởng +500P",
        invite_desc: "Chia sẻ liên kết. Bạn và bạn bè đều nhận 500P!",
        invited_count: "Bạn đã mời",
        unit_people: "người",
        edit_profile_title: "Chỉnh sửa hồ sơ",
        label_photo: "Ảnh hồ sơ",
        btn_upload: "Tải lên",
        btn_random: "Ngẫu nhiên",
        placeholder_photo_url: "Hoặc URL hình ảnh",
        label_nickname: "Biệt danh",
        label_bio: "Giới thiệu",
        placeholder_bio: "Giới thiệu ngắn gọn về bản thân"
    },

    plaza: {
        title: "Ssulwha Club",
        subtitle: "Không gian giao tiếp cảm xúc cho Gen Z",
        btn_sync: "⚡ Đồng bộ bình luận (Admin Only)",
        composer_placeholder_init: "Bạn muốn phóng câu chuyện nào vào vũ trụ này?",
        composer_placeholder_thread: "Viết tiếp câu chuyện...",
        composer_placeholder_quote: "Để lại suy nghĩ về câu chuyện này...",
        btn_add_thread: "Thêm luồng",
        btn_submit: "Phóng sao",
        btn_submit_quote: "Trích dẫn",
        btn_submitting: "Đang tải...",
        quote_suffix: " trích dẫn"
    },
    recommendation: {
        loading_title: "Đang đọc quỹ đạo của bạn...",
        loading_desc: "Kết nối những bước đi trong quá khứ và những ngôi sao bạn đã dừng chân",
        fallback_title: "Chòm sao của <span class=\"text-transparent bg-clip-text bg-gradient-to-r from-fuchsia-200 to-amber-200\">{name}</span><br>vẫn còn mờ nhạt.",
        fallback_desc: "Nhưng đừng lo lắng. <br>Chúng tôi đã chọn những câu chuyện tỏa sáng từng thắp sáng đêm của nhiều người khác.<br><span class=\"text-sm opacity-70 mt-1 block\">Khi dấu chân của bạn nhiều lên, chúng tôi sẽ tìm thấy quỹ đạo dành riêng cho bạn.</span>",
        personal_title: "Kệ sách của <span class=\"text-transparent bg-clip-text bg-gradient-to-r from-fuchsia-200 to-amber-200\">{name}</span>,<br>Câu chuyện cho ngăn tiếp theo",
        personal_desc: "Chúng tôi đã tìm thấy 5 ngôi sao cộng hưởng với sở thích của bạn.",
        label_empty_shelf: "Kệ sách trống (The Empty Shelf)",
        btn_refresh: "Gợi ý khác",
        error_title: "Kết nối không ổn định",
        btn_retry: "Thử lại",
        empty_data_title: "Không đủ dữ liệu",
        btn_browse: "Duyệt tác phẩm",
        widget_title: "Tìm cuốn sách<br>tiếp theo?",
        widget_desc: "Chúng tôi đã chọn 5 tác phẩm dựa trên sở thích của {name}.",
        widget_desc_guest: "Chúng tôi đã chọn 5 tác phẩm dựa trên sở thích của bạn.",
        btn_check: "Xem ngay"
    },
    star_station: {
        title: "Trạm Ngôi Sao",
        subtitle: "Thưởng thức tác phẩm tự do hơn.",
        my_stars: "Sao của tôi",
        history_tab: "Lịch sử",
        products_tab: "Sản phẩm",
        payment_method: "Phương thức thanh toán",
        btn_charge: "Nạp tiền",
        history_empty: "Không có lịch sử nạp tiền.",
        product_names: {
            stardust: "Bụi sao",
            shooting_star: "Sao băng",
            little_bear: "Tiểu Hùng Tinh",
            silver_river: "Ngân Hà Bạc",
            galaxy_master: "Chúa Tể Thiên Hà",
            star_maker: "Người Tạo Sao"
        }
    },
    studio: {
        title: "Studio Sáng tạo",
        desc: "Không gian cho trí tưởng tượng vô tận của bạn.",
        dashboard: "Bảng điều khiển",
        series: "Quản lý Series",
        statistics: "Thống kê",
        profit: "Doanh thu",
        guide: "Hướng dẫn Tác giả",
        new_series: "Series mới",
        edit_series: "Chỉnh sửa Series",
        new_episode: "Tập mới",
        edit_episode: "Chỉnh sửa Tập",
        open_menu: "Mở menu",
        exit: "Thoát",
        lab_badge: "LAB",
        lab_title: "Phòng thí nghiệm Da Vinci",
        lab_desc: "Mở ra thế giới sáng tạo mới với AI.",
        total_views: "Lượt xem",
        total_likes: "Lượt thích",
        total_followers: "Người theo dõi",
        weekly_performance: "Hiệu suất hàng tuần",
        views_trend_7d: "Xu hướng xem (7 ngày)",
        live_data: "TRỰC TIẾP",
        my_series_list: "Tác phẩm của tôi",
        total_series_count: "Tổng {n} tác phẩm",
        empty_series_title: "Bắt đầu câu chuyện mới",
        empty_series_desc: "Mở ra trí tưởng tượng của bạn với thế giới.",
        btn_editor: "Trình biên tập",
        btn_settings: "Cài đặt",
        btn_delete: "Xóa",
        delete_modal_title: "Xóa series",
        create_first_episode: "Tạo tập đầu tiên của bạn!",
        create_first_episode_desc: "Nhấp vào nút Tập mới để bắt đầu.",
        last_updated: "Cập nhật lần cuối: {date}",
        delete_episode_title: "Xóa tập",
        delete_episode_content: "Bạn có chắc chắn muốn xóa tập '{title}' không?",

        // Toolbar
        bold: "In đậm",
        italic: "In nghiêng",
        highlight_red: "Tô sáng (Đỏ)",
        highlight_blue: "Tô sáng (Xanh)",
        save_preserve_status: "Lưu (Giữ nguyên trạng thái)",
        delete_modal_content: "Bạn có chắc chắn muốn xóa '{title}'? Hành động này không thể hoàn tác."
    },
    editor: {
        davinci_editor: "Trình biên tập DaVinci",
        webnovel_editor: "Trình biên tập Webnovel",
        webtoon_editor: "Trình biên tập Webtoon",
        episode_title: "Tiêu đề Tập",
        placeholder_title: "Nhập tiêu đề tập",
        content: "Nội dung",
        placeholder_content: "Viết câu chuyện của bạn ở đây...",
        author_note: "Ghi chú Tác giả",
        placeholder_note: "Lời nhắn cho độc giả...",
        upload_image: "Tải ảnh lên",
        upload_cover: "Tải ảnh bìa",
        save_draft: "Lưu nháp",
        publish: "Xuất bản",
        ai_analysis: "Phân tích AI",
        ai_recommend: "Gợi ý AI",
        tags: "Thẻ",
        placeholder_tags: "Thêm thẻ (phân tách bằng dấu phẩy)",
        preview: "Xem trước",
        cover_image: "Cover Image",
        cover_url: "Cover URL",
        series_status: "Series Status",
        admin_info: "Admin Info",
        format: "Format",

        publish_now: "Publish",
        settings: "Cài đặt",
        episode_prefix: "Tập",
        draft_mode_title: "Chế độ Nháp",
        draft_mode_private_desc: "Tập này hiện đang ẩn.",
        display_mode: "Chế độ hiển thị",
        mode_webtoon: "Webtoon (Cuộn)",
        mode_comic: "Comic (Trang)",
        mode_insta: "InstaToon",
        mode_desc: "Tối ưu hóa trải nghiệm xem.",
        thumbnail: "Hình thu nhỏ",
        bgm: "BGM",
        manuscript_images: "Bản thảo",
        drag_drop_hint: "Kéo thả hình ảnh hoặc Nhấn để tải lên",
        set_draft: "Về Nháp",
        save_changes: "Lưu thay đổi",

        preview_hint: "Kiểm tra hiển thị trên thiết bị di động.",
        val_webtoon_error: "[Lỗi Chế độ Webtoon] Hình ảnh quá rộng (Tỷ lệ: {ratio}).<br>Chế độ Webtoon yêu cầu cuộn dọc (Cao > Rộng * 1.2).<br>Đối với trang đơn, hãy dùng chế độ 'Comic'.",
        val_comic_error: "[Lỗi Chế độ Comic] Tỷ lệ khung hình không hợp lệ ({ratio}).<br>Định dạng cho phép:<br>- Trang dọc (khoảng 2:3 đến 3:4)<br>- Trang đôi ngang (Rộng > Cao)<br><br>Dải cuộn dài nên dùng chế độ 'Webtoon'.",
        val_insta_error: "[Lỗi InstaToon] Tỷ lệ khung hình không hợp lệ ({ratio}).<br>Tối ưu cho Instagram yêu cầu Vuông (1:1) hoặc Chân dung (4:5).<br>Hình ảnh hiện tại quá rộng hoặc quá cao.",
        approval_requested: "Đã yêu cầu phê duyệt",
        approval_desc: "Đây là lần xuất bản đầu tiên cho series này.<br>Quản trị viên sẽ sớm xem xét.",
        pending_approval: "Đang chờ phê duyệt",
        saved_to_draft: "Đã lưu vào Nháp",
        published_start_ai: "Tập đã xuất bản! Đang chạy Phân tích AI...",
        ai_trigger_fail: "Khởi động Phân tích AI thất bại. Vui lòng dùng nút 'Phân tích AI' thủ công.",
        save_failed: "Lỗi lưu: {e}",
        upload_complete: "Tải lên hoàn tất",
        upload_fail_desc: "Tải ảnh thất bại. (Tạo URL thất bại)\nVui lòng kiểm tra nhật ký console.",
        image_mode_mismatch: "Ảnh đã chọn không khớp với thông số kỹ thuật chế độ {mode}.",
        invalid_format: "Định dạng không hợp lệ",
        mode_change_blocked: "Chặn đổi chế độ",
        mode_change_blocked_desc: "Một số ảnh hiện có không khớp với thông số {mode}. Vui lòng xóa chúng và thử lại.",
        processing: "Đang xử lý...",
        tap_nav_hint: "Nhấn cạnh để điều hướng hoặc Cuộn",
        ai_analyze_title: "Xác nhận Phân tích AI",

        save_required: "Vui lòng lưu tập trước.",
        ai_requesting: "Đang yêu cầu Máy chủ AI... (OCR/SEO)",
        ai_processing_title: "Xử lý AI",
        ai_no_items: "Không có mục nào được phân tích (0).\\n\\n[Chi tiết]\\n{log}",
        diagnosis_report: "Báo cáo chẩn đoán",
        ocr_complete: "Hoàn tất OCR: {n} khung hình",
        seo_trigger: "Đã kích hoạt Tự động tạo SEO.",
        ai_complete_desc: "Phân tích Hoàn tất.\\n- Dữ liệu OCR Đã tạo\\n- Siêu dữ liệu SEO Đang chờ\\n(Sẽ hiển thị ngay)",
        ai_error: "Lỗi Xử lý AI",
        ai_fail_msg: "Phân tích AI Thất bại: {e}",
        title: "Novel Studio",
        master_detail: "Master-Detail View",
        save: "Lưu",
        saved: "Đã lưu",
        saving: "Đang lưu...",
        complete: "Hoàn tất",



        error: "Lỗi",
        ai_analyze_btn: "Phân tích AI",
        ai_analyzing: "Đang phân tích...",
        series_info: "Thông tin Series (Upload)",
        series_title: "Tên Series",

        admin_readonly: "Chỉ Admin (Read Only)",
        chapters: "Danh sách chương",
        add_chapter: "Thêm chương",
        delete_chapter_confirm: "Xóa chương này?",
        untitled_episode: "Không tiêu đề",
        bgm_label: "BGM (tùy chọn)",
        content_body: "Nội dung",
        load_txt: "Tải TXT",
        text_too_short: "Văn bản quá ngắn.",
        upload_cover_fail: "Lỗi tải ảnh bìa",
        create_series: "Tạo Series",
        edit_series: "Sửa Series",
        basic_info: "Thông tin cơ bản",
        episode_mgmt: "Quản lý tập",
        compliance: "Tuân thủ (Compliance)",
        age_rating: "Độ tuổi",
        age_guide: "Hướng dẫn",
        is_ai: "Sử dụng nội dung AI",
        desc_placeholder: "Nhập mô tả cốt truyện...",


        format_locked: "Đã khóa",
        webtoon: "Webtoon (Webtoon)",
        webnovel: "Tiểu thuyết (Webnovel)",
        cinenovel: "Cine-Novel",
        admin_id: "ID Code (Admin Only)",
        ai_context_analysis_confirm: "Run AI Context Analysis?\n(Existing data will be overwritten)",
        ai_analyzing_background: "Requesting AI Analysis... (Background)",
        ai_no_items_found: "No items analyzed...",
        upload_fail: "Upload Failed: ",
        creating_episode: "Creating New Episode...",
        episode_not_found: "Episode not found.",
        uploading_images_toast: "Uploading images...",
        approval_request_sent: "Approval request sent. (Pending Admin Review)",
        publish_success: "Successfully Published!",
        temp_saved_toast: "Temporarily Saved.",
        deleted_toast: "Deleted.",
        access_denied: "Access Denied",


        series_info_upload: "Series Info (Upload)",
        cover_upload_fail: "Cover Upload Failed: ",
        save_success: "Saved",




        free_limit_placeholder: "Leave empty for global/series default",
        free_limit_desc: "* Overrides global settings if set.",
        admin_edit_anytime: "* Admin can edit this anytime.",
        status_published: "Đã xuất bản",
        status_draft: "Bản nháp",
        edit_detail_guide: "Sửa chi tiết trong trình biên tập",
        refreshing_list: "Đang làm mới danh sách...",
        load_fail: "Lỗi tải: ",
        no_cover: "Không có bìa",
        badge_ai: "AI tạo",
        no_episodes: "Chưa có tập nào.",


        preview_preparing: "Đang chuẩn bị xem trước...",

        select_chapter: "Chọn một tập",
        episode_placeholder: "ví dụ) Tập 1",
        bgm_placeholder: "URL Suno AI...",

        ai_analysis_fail: "Phân tích AI thất bại: ",
        save_fail: "Lưu thất bại: ",
        back_to_list: "Quay lại danh sách",
        bold: "Đậm",
        italic: "Nghiêng",
        highlight_red: "Nổi bật (Đỏ)",
        highlight_blue: "Nổi bật (Xanh)",


        publish_complete: "Xuất bản hoàn tất",
        save_complete: "Lưu hoàn tất",
        publish_confirm: "Bạn có chắc chắn muốn xuất bản?",
        ai_analyze_confirm: "Bắt đầu phân tích AI?",
        novel_editor: "Trình biên tập tiểu thuyết",
        auto_saved: "Đã tự động lưu",
        untitled_chapter: "Không tiêu đề",
        chapter_title_placeholder: "Tiêu đề chương",
        publish_settings: "Cài đặt xuất bản",
        delete_title: "Xóa chương",
        save_button: "Lưu",
        novel_info: "Thông tin tiểu thuyết",
        novel_title: "Tiêu đề tiểu thuyết",
        tags_placeholder: "Lãng mạn, Giả tưởng",
        chapter_list: "Danh sách chương",
        chapter_count: "Tổng {n} tập",
        add_empty_chapter: "Thêm chương trống",
        live_preview: "Xem trước trực tiếp",
        public_toggle: "Công khai",
        private_toggle: "Riêng tư",
        bgm_suno_label: "Cài đặt BGM",
        txt_upload: "Tải lên TXT",
        content_placeholder: "Nhập nội dung...",
        note_placeholder: "Ghi chú của tác giả...",
        ai_analysis_complete: "Phân tích AI hoàn tất",
        recommend_keywords: "Từ khóa",
        hook: "Móc câu (Hook)",
        analysis_saved: "Dữ liệu đã lưu.",
        analysis_fail: "Phân tích thất bại.",
        analysis_short: "Nội dung quá ngắn.",
        age_all: "Tất cả",
        age_12: "12+",
        age_15: "15+",
        age_19: "19+",
        rating_label: "Xếp hạng",
        age_19_desc: "Chặn người chưa thành niên.",
        age_lock_warning: "Cảnh báo: Không thể thay đổi sau khi lưu.",
        free_limit: "Giới hạn miễn phí (Local Override)",
        cancel: "Hủy",
        create: "Tạo",
        episode_list: "Danh sách tập",
        open_editor_fullscreen: "Mở trình biên tập (Toàn màn hình)",
        editor_guide_text: "* Sử dụng 'Mở trình biên tập' để thay đổi nội dung.",
        admin_zone: "Khu vực Admin",
        admin_zone_desc: "Thông tin này bị giới hạn.",
        download_csv: "Tải CSV (ISBN)",
        adult_confirm_title: "Cảnh báo 18+",
        adult_confirm_body: "Đặt là 'Người lớn (19+)'?\n\n- Chặn truy cập đối với người chưa thành niên.\n- Có thể yêu cầu xác minh danh tính.",
        davinci_lock_title: "🚧 Đang phát triển",
        davinci_lock_desc: "Chế độ Da Vinci (Cine-Novel) đang thử nghiệm.<br>Chỉ dành cho <strong>Quản trị viên</strong> do tính không ổn định.<br><div class='mt-3 text-rose-400 font-bold'>Sắp ra mắt.</div>",

        ai_analyze_local: "AI Context Analysis",
        ai_confirm: "AI Confirmation",
    },

    rating_guide: {
        title: "Hướng dẫn Xếp hạng Nội dung",
        all_title: "Mọi lứa tuổi",
        all_desc: "Nội dung phù hợp với mọi lứa tuổi.<br>Không hoặc rất ít bạo lực, nội dung tình dục hoặc ngôn từ không phù hợp.",
        title_12: "12+ (Thiếu niên)",
        desc_12: "Có thể chứa bạo lực nhẹ, ngôn từ thô tục hoặc kinh dị.<br>Khuyến nghị sự hướng dẫn của phụ huynh cho trẻ dưới 12 tuổi.",
        title_15: "15+ (Thanh niên)",
        desc_15: "Có thể chứa bạo lực vừa phải, ngôn từ mạnh hoặc chủ đề trưởng thành.<br>Có thể mô tả hành vi phạm tội hoặc cấm kỵ xã hội.",
        title_19: "19+ (Chỉ người lớn)",
        desc_19: "Chứa nội dung tình dục rõ ràng, bạo lực cực đoan hoặc ngôn từ lăng mạ.<br><strong class='text-red-500'>Bị giới hạn pháp lý cho người lớn trên 19 tuổi. Yêu cầu xác minh danh tính.</strong>",
        disclaimer: "* Xếp hạng là trách nhiệm của tác giả. Xếp hạng sai có thể dẫn đến thay đổi bắt buộc hoặc hình phạt.",
        confirm: "Đã hiểu"
    },
    davinci: {
        episode_settings: "Cài đặt tập",
        title: "Tiêu đề",
        thumbnail: "Hình thu nhỏ",
        bgm: "BGM",
        add_block: "Thêm khối",
        text_block: "Văn bản",
        image_block: "Hình ảnh",
        upload_image: "Tải ảnh",
        upload_thumb: "Tải hình thu nhỏ",
        upload_success: "Đã tải lên",
        bgm_placeholder: "Suno URL hoặc liên kết MP3",
        tip: "Mẹo:",
        drag_tip: "Kéo thả các khối để sắp xếp.",
        save_draft: "Lưu nháp",
        publish: "Xuất bản",
        saving: "Đang lưu...",
        published: "Đã xuất bản! Độc giả có thể xem.",
        publish_confirm: "Xuất bản ngay? Độc giả sẽ thấy tập này.",
        preview_preparing: "Đang chuẩn bị xem trước...",
        thumbnail_uploading: "Đang tải hình thu nhỏ...",
        thumbnail_applied: "Đã áp dụng hình thu nhỏ",
        guide: {
            title: "Hướng dẫn nút",
            save: "Lưu",
            save_desc: "Lưu thay đổi.",
            draft: "Bản nháp",
            draft_desc: "Chuyển sang riêng tư.",
            publish: "Xuất bản",
            publish_desc: "Công khai. (Độc giả có thể xem)",
            auto_save: "Tự động lưu",
            auto_save_on: "BẬT (3s)",
            auto_save_desc: "Tự động lưu mỗi 3 giây."
        }
    },
    intro: {
        slogan: "Sáng Tạo Của Con Người, Khả Năng Mở Rộng Của AI",
        hero_title: "Cá Babel",
        hero_subtitle: "cho Tiểu thuyết Điện ảnh.",
        status_active: "Công cụ Dịch thuật Đang hoạt động",
        status_cine: "Định dạng Cine-Novel",
        desc_1: "Đọc ngay IP Hàn Quốc bằng <span class='text-white font-bold mx-1'>10 ngôn ngữ</span> với công cụ AI không phá hủy của chúng tôi.",
        desc_2: "Trải nghiệm <span class='text-white font-bold mx-1'>Định dạng Lai đầu tiên trên thế giới</span> nơi hình ảnh và tiểu thuyết hòa quyện.",
        cta_start: "Bắt đầu đọc miễn phí",
        compare_title: "Phá hủy vs Không phá hủy",
        compare_desc: "Chúng tôi không bao giờ chạm vào pixel gốc. Hãy xem sự khác biệt.",
        compare_old: "Phương pháp cũ (Hộp trắng)",
        compare_new: "Công cụ Ssulwha (R.A.P.S)",
        white_box_removed: "Đã xóa hộp trắng",
        format_title: "Vượt qua hình ảnh tĩnh",
        format_desc: "Hình ảnh Webtoon. Chiều sâu tiểu thuyết. Nhập vai điện ảnh.",
        geo_title: "Tăng trưởng dựa trên AI",
        geo_desc: "Chúng tôi không làm tiếp thị. AI của chúng tôi làm điều đó.",
        term_log_1: "Đang phân tích nội dung...",
        term_log_2: "Trích xuất từ khóa...",
        term_log_3: "Tiêm dữ liệu JSON-LD...",
        term_log_4: "Tăng trưởng tự nhiên +300%",

        // Missing Keys Added
        slider_old_title: "Phương pháp cũ",
        slider_old_desc: "CHE KHUẤT NGHỆ THUẬT",
        slider_new_title: "Công cụ Ssulwha (R.A.P.S)",
        slider_new_desc_1: "\"Đây là cách nó nên xảy ra.\"",
        slider_new_desc_2: "Văn bản trôi nổi tự nhiên, bảo tồn tác phẩm nghệ thuật.",

        phone_analyzing: "Đang phân tích...",
        phone_detected: "Đã phát hiện",
        phone_text_1: "Đây có phải là định mệnh của tôi không?",
        phone_cine_ep: "CINE-NOVEL TẬP 01",
        phone_cine_text_1: "Đèn neon nhấp nháy, phản chiếu trong đôi mắt lạnh lùng của anh.",
        phone_cine_text_2: "\"Nó không chỉ là một bản dịch,\" anh lẩm bẩm. \"Đó là một thực tế mới.\"",

        footer_copyright: "Được cung cấp bởi R.A.P.S Engine."
    }
};
